export default "__VITE_ASSET__fFIjO3il__"